var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExploLogoWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 326.1 93.3",
    style: {
      enableBackground: "new 0 0 326.1 93.3"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M179.2,42.1c1.3-1.1,2.6-1.9,5.6-2.2v5l-1.9,0.3c-2.7,0.5-3.5,0.9-3.5,3.3v10.8h-5.7V40.1h5.5V42.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M198.3,50.2c0,2-0.1,3.8-2,5c-0.6,0.4-1.3,0.6-2,0.6c-1.3,0-2.1-1-2.1-2c0-1.5,1.5-2,2.4-2.4L198.3,50.2z  M193.1,45.6c0.1-0.7,0.5-2.3,3-2.3c2,0,2.1,1.5,2.2,2.4v1c-2.4,0.4-6,1.1-7.6,1.8c-1.6,0.7-4.1,2.4-4.1,5.5 c0,2.7,1.9,5.9,6.3,5.9c2.8,0,4.5-1.2,5.9-2.3v1.8h5.6c-0.4-0.7-0.6-1-0.6-3V45.1c0-5-5.7-5.5-8.1-5.5c-2.3,0-4.5,0.3-6.3,1.7 c-1.7,1.4-1.9,2.9-2,4.3H193.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M209.7,34.5h5.7v6h3.7V44h-3.8v8.7c0,1.2,0,2.2,1.5,2.2l2-0.1v4.4c-1.2,0.2-2,0.3-3,0.3c-2,0-4.1-0.1-5.3-1.9 c-0.8-1.1-0.8-2.5-0.8-4.4V44h-2.8v-3.5h2.8V34.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M230.8,44c0.8-0.1,2.1,0,3.3,1.1c1.1,1,1.6,2.7,1.6,4.9c0,3-1.5,5.5-4.6,5.5c-3.2,0-4.7-2.7-4.7-5.8 c0-1.3,0.3-2.7,1-3.8C228.2,44.7,229.2,44.1,230.8,44z M231.9,39.5c-7.4-0.4-11.1,4.3-11.1,10.2c0,7.1,4.9,10.2,10.3,10.2 c7.5,0,10.3-5.3,10.3-10.2C241.5,46.2,239.8,40,231.9,39.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M250.6,42.1c1.3-1.1,2.6-1.9,5.6-2.2v5l-1.9,0.3c-2.7,0.5-3.5,0.9-3.5,3.3v10.8h-5.7V40.1h5.5V42.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M259,33.3h5.6v4.4H259V33.3z M259,40.1h5.6v19.3H259V40.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M281.3,40.2h5.7v19.2h-5.7v-1.8c-0.6,0.6-0.9,1-1.9,1.5c-1.1,0.6-2.4,0.9-3.7,0.9c-1.2,0-3.6-0.2-4.9-2 c-1-1.4-1.2-2.5-1.2-5.7V40.2h5.7v11.9c0,0.8,0,1.7,0.4,2.3c0.3,0.4,1.1,1,2.3,1c0.3,0,1.1,0,2-0.5c1.2-0.7,1.3-1.7,1.3-2.7V40.2z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M297.6,42.2c0.7-0.8,2.1-2.5,5.4-2.5c3.2,0,4.3,1.2,5.4,2.3c1.1-0.9,2.6-2.3,5.7-2.3c3.2,0,4.8,1.6,5.4,2.8 c0.5,1,0.5,2.4,0.5,4.4v12.5h-5.6V49.3c0-1.1,0-2.5-0.2-3.3c-0.5-1.6-2-1.7-2.5-1.7c-0.6,0-1.3,0.1-1.8,0.6 c-1.1,0.8-1.1,2-1.1,4.1v10.5h-5.6V48c0-0.8,0-2-0.6-2.7c-0.4-0.6-1.3-1-2.2-1c-0.4,0-1,0.1-1.5,0.4c-1.2,0.8-1.3,2.4-1.3,3.7v11 H292V40.2h5.6V42.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M5.8,47.4c0.2-0.8,0.4-1.7,1.1-2.5c0.5-0.6,1.5-1.2,2.9-1.2c1,0,2.1,0.4,2.8,1.1c0.8,0.8,1,1.9,1.1,2.7H5.8z  M15,52.3c-0.7,1.4-1.8,3.4-4.9,3.4c-3.1,0-4.4-2.4-4.4-4.9h13.8c-0.1-2.2-0.2-5.9-2.7-8.6c-2.5-2.6-5.8-2.8-6.9-2.8 C2.3,39.5,0,45.5,0,50.1c0,6.4,4,10,9.7,10c3.1,0,5.6-1.2,7.3-2.7c1-0.9,1.7-1.9,2.3-2.9L15,52.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M38.8,40.2l-5.8,9l6.5,10.2h-6.1l-3.7-6l-3.2,6h-6.3L26.8,49L21,40.2h6.4l2.5,4.9l2.7-4.9H38.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M52.2,43.9c2.3,0.6,3,3.3,3,5.8c0,3-1.2,6-4,6c-0.9,0-1.9-0.4-2.6-1.1c-0.7-0.8-1.4-2.3-1.4-4.7 c0-1.8,0.4-3.5,1.2-4.5c0.8-1.1,1.9-1.5,2.9-1.5C51.7,43.8,52,43.8,52.2,43.9z M46.9,40.2h-5v25.9h5.7v-7.9 c1.5,0.9,2.6,1.6,4.8,1.6c6.6,0,8.3-6.1,8.3-10.1c0-6.4-3.6-10-8.4-10c-2.2,0-3.9,0.8-4.9,1.7c-0.2,0.1-0.4,0.3-0.5,0.6V40.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M70,33.3v26.1h-5.7V33.3H70z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M121.7,93.3c25.7,0,46.6-20.9,46.6-46.6c0-25.7-20.9-46.6-46.6-46.6C96,0,75.1,20.9,75.1,46.6 C75.1,72.4,96,93.3,121.7,93.3z M80.6,46.6c0-22.7,18.4-41.1,41.1-41.1c22.7,0,41.1,18.4,41.1,41.1c0,22.7-18.4,41.1-41.1,41.1 C99.1,87.7,80.6,69.3,80.6,46.6z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M322.9,39.4c-1.6,0-3.1-1.3-3.1-3.1c0-1.8,1.4-3.1,3.1-3.1c1.8,0,3.1,1.4,3.1,3.1 C326,38,324.7,39.4,322.9,39.4z M322.9,33.4c-1.6,0-2.8,1.3-2.8,2.8c0,1.6,1.3,2.8,2.8,2.8c1.6,0,2.8-1.3,2.8-2.8 C325.8,34.7,324.6,33.4,322.9,33.4z M322.9,34.3c0.4,0,0.7,0,0.9,0.1c0.4,0.1,0.6,0.5,0.6,0.9c0,0.5-0.3,0.8-0.8,0.9 c0.3,0.1,0.5,0.3,0.6,0.8c0.1,0.6,0.1,0.8,0.3,1.2h-0.8c0-0.1-0.1-0.2-0.2-0.5c0-0.1-0.1-0.5-0.1-0.6c-0.1-0.6-0.4-0.6-0.9-0.6 h-0.2v1.8h-0.7v-3.9H322.9z M322.3,35.9h0.6c0.3,0,0.8,0,0.8-0.5c0-0.1-0.1-0.4-0.3-0.5c-0.1-0.1-0.2-0.1-0.7-0.1h-0.4V35.9z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExploLogoWhite);
export default __webpack_public_path__ + "static/media/explo-logo-white.974ca5802bf4b3144a6f725e7c366caf.svg";
export { ForwardRef as ReactComponent };